module.exports = __webpack_public_path__ + "static/d0f07a888952e9d95b49af229b50b00c.svg";